import type {
  IDynamicFeedbackResult,
  IDynamicFeedbackSubmission,
  IDynamicFeedbackTargets,
} from '@common/interfaces/dynamicEnvFeedback'
import Base from './base'

export default class DynamicEnvFeedback extends Base {
  listTargets() {
    return this.apiClient.get('dynamic-env-feedback/targets') as Promise<IDynamicFeedbackTargets>
  }

  submit(data: IDynamicFeedbackSubmission) {
    return this.apiClient.post('dynamic-env-feedback', data) as Promise<IDynamicFeedbackResult>
  }
}
